//コンポーネントもジェネリクス
type ComponentControlProps<T, Component extends React.ElementType> = {
  componentName: Component;
  items: T[];
  isLoading: boolean;
  noDataMessege: string;
} & Omit<React.ComponentPropsWithoutRef<Component>, 'ref' | 'items'>;

//コンポーネント名、データ内容、フェッチ結果（bool）、データなしの場合の文言、restが各コンポーネントによって引数が違うので色々入れれるっぽい？
export const ComponentControl = <T, Component extends React.ElementType>({
  componentName,
  items,
  isLoading,
  noDataMessege,
  ...rest
}: ComponentControlProps<T, Component>) => {
  if (!isLoading && items?.length === 0) {
    return <div>{noDataMessege}</div>;
  }

  const Component = componentName;

  return <Component {...(rest as any)} items={items} />;
};
